import React, { useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { AuthContext } from '../../../../helpers/AuthContext';
import InstanceLeftSidebar from '../../InstanceLeftSidebar';
import PageHeaderWithBreadcrumbs from '../../../../components/PageHeaderWithBreadcrumbs';
import MaterialsManagement from './MaterialsManagement';

const EliteProductionMaterialsManagement = () => {
  const { authState } = useContext(AuthContext);

  return (
    <div className="instance-dashboard">
      <InstanceLeftSidebar />
      <div className="rightSide">
        <div className="options-container fade-in-effect-usability">
          <div className="options-inner-container">
            <PageHeaderWithBreadcrumbs
              title="Materials Management"
              breadcrumb="Materials Management"
              includeButton={false}
            />
            <MaterialsManagement />
          </div>
        </div>
      </div>
    </div>
  );
};

//  return (
//     <div className="instance-dashboard">
//       <InstanceLeftSidebar />
//       <div className="rightSide">
//         <div className="options-container fade-in-effect-usability">
//           <div className="options-inner-container" style={{ maxWidth: '100%', width: '100%', padding: 0 }}>
//             <PageHeaderWithBreadcrumbs
//               title="Materials Management"
//               breadcrumb="Materials Management"
//               includeButton={false}
//             />
//             <MaterialsManagement />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

export default EliteProductionMaterialsManagement;
